import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=a9aba9a4&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
import style0 from "./Category.vue?vue&type=style&index=0&id=a9aba9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aba9a4",
  null
  
)

export default component.exports